import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from '../../../../../assist/src/app/_shared/services/base.service';
import { UserPersonDto, UserPersonListDto } from "../models/user-person";

@Injectable({
  providedIn: "root",
})
export class UserPersonService extends BaseService<UserPersonDto, UserPersonListDto> {
  constructor(
    protected override http: HttpClient,
    @Inject("PUBLIC_BASE_URL") protected override baseUrl: string
  ) {
    super(http, baseUrl, "userPerson");
  }


  addToUser(memberOrPersonKey: string, organizationKey: string): Observable<UserPersonListDto> {
    const url = `${this.baseUrl}userPerson/add?memberOrPersonKey=${(memberOrPersonKey)}&organizationKey=${(organizationKey)}`;
    return this.http.post<UserPersonListDto>(url, {});
  }

}
